@if (icon === 'arrow') {
  <pcp-slide-sync-toolbar-button
    svgIcon="pcp-arrow"
    (toggle)="toggleArrow()"
    [turnedOn]="(isActivated$ | async) === true"
    [disabled]="(isDrawingEnabled$ | async) === false"
  ></pcp-slide-sync-toolbar-button>
} @else {
  <pcp-slide-sync-toolbar-button
    [matIcon]="icon"
    [fontSet]="fontSet"
    (toggle)="toggleArrow()"
    [turnedOn]="(isActivated$ | async) === true"
    [disabled]="(isDrawingEnabled$ | async) === false"
  ></pcp-slide-sync-toolbar-button>
}

